import { cn } from '../../utils/cn';
const baseClasses = 'inline-flex h-8 w-8 shrink-0 items-center justify-center border-0 [&_svg]:h-4 [&_svg]:w-4';
const shapeClasses = {
    square: 'rounded-none',
    round: 'rounded-full',
};
const variantClasses = {
    darkGrey: 'bg-interactive-loud text-interactive hover:text-interactive-hover hover:bg-interactive-louder',
    grey: 'bg-interactive text-interactive hover:text-interactive-hover hover:bg-interactive-loud',
    white: 'bg-static text-static hover:bg-static-loud',
};
// Ancestor-hover appearance for decorative icons nested in a whole-item link marked `group`
// (e.g. `Tile`/`Card`): hovering anywhere on the link — not just the icon — shows the hover state.
// Mirrors each variant's own `hover:` colours.
const groupHoverVariantClasses = {
    darkGrey: 'group-hover:text-interactive-hover group-hover:bg-interactive-louder',
    grey: 'group-hover:text-interactive-hover group-hover:bg-interactive-loud',
    white: 'group-hover:bg-static-loud',
};
// Disabled appearance, driven by base-ui's `data-disabled` styling hook (IconButton only).
const disabledClasses = 'data-disabled:cursor-not-allowed data-disabled:bg-interactive-disabled data-disabled:text-interactive-disabled data-disabled:hover:bg-interactive-disabled';
// Single source of Tailwind classes shared by `IconButton` (an action) and `IconButtonLink`
// (navigation). Pass `groupHover` for decorative icons whose hover state should also react to an
// ancestor link marked `group`.
export const iconButtonStyles = ({ variant = 'darkGrey', shape = 'square', className, groupHover = false, }) => cn(baseClasses, shapeClasses[shape], variantClasses[variant], groupHover && groupHoverVariantClasses[variant], disabledClasses, className);
